export default __webpack_public_path__ + "static/media/icons8-image-file.d2261d63.svg";